import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { ListItem } from "../menu/ListItem";
import { AiOutlineDelete } from "react-icons/ai";
import Modal from "react-modal";
import { CustomModalStyles, ModalDeleteCloseButtonBar, ModalTitle } from "../modal/ModalComponents";
import { RiErrorWarningLine } from "react-icons/ri";
import styled from "styled-components";
export const WarnIndicatorIcon = styled(RiErrorWarningLine).withConfig({
  displayName: "AdvancedListItem__WarnIndicatorIcon",
  componentId: "sc-103tibl-0"
})(["vertical-align:bottom;font-size:18px;margin-right:4px;color:red;"]);
const ListItemFlex = styled(ListItem).withConfig({
  displayName: "AdvancedListItem__ListItemFlex",
  componentId: "sc-103tibl-1"
})(["display:flex;flex-wrap:nowrap;justify-content:space-between;white-space:nowrap;"]);
const ItemNameAndIcon = styled.div.withConfig({
  displayName: "AdvancedListItem__ItemNameAndIcon",
  componentId: "sc-103tibl-2"
})(["overflow-x:clip;display:flex;*{flex-shrink:0;}"]);
const ItemName = styled.div.withConfig({
  displayName: "AdvancedListItem__ItemName",
  componentId: "sc-103tibl-3"
})(["text-overflow:ellipsis;white-space:nowrap;"]);
const DeleteButton = styled.div.withConfig({
  displayName: "AdvancedListItem__DeleteButton",
  componentId: "sc-103tibl-4"
})(["margin-top:-2px;float:right;font-size:x-large;color:#555555;height:18.39px;&:hover{color:black;}"]);
export const AdvancedListItem = observer(props => {
  const {
    t
  } = useTranslation();
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal(e) {
    e.stopPropagation();

    if (props.deleteWithoutConfirmation) {
      props.onConfirmDelete(props.itemId);
      return;
    }

    setIsOpen(true);
  }

  function closeModal(e) {
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    setIsOpen(false);
  }

  function confirm() {
    closeModal();
    props.onConfirmDelete(props.itemId);
  }

  return /*#__PURE__*/React.createElement(ListItemFlex, {
    className: props.isSelected ? "selected" : "",
    onClick: () => {
      props.onSelectItem(props.itemObject);
    }
  }, /*#__PURE__*/React.createElement(ItemNameAndIcon, null, props.icon, props.icon && /*#__PURE__*/React.createElement("span", null, "\xA0"), props.showWarnIndicator && /*#__PURE__*/React.createElement(WarnIndicatorIcon, null), props.itemName ? /*#__PURE__*/React.createElement(ItemName, null, props.itemName) : /*#__PURE__*/React.createElement(ItemName, null, "\xA0")), props.isSelected && props.onConfirmDelete && /*#__PURE__*/React.createElement(React.Fragment, null, props.allowDeletion && /*#__PURE__*/React.createElement(DeleteButton, {
    onClick: e => openModal(e)
  }, /*#__PURE__*/React.createElement(AiOutlineDelete, null)), /*#__PURE__*/React.createElement(Modal, {
    isOpen: modalIsOpen,
    onRequestClose: closeModal,
    shouldCloseOnOverlayClick: true,
    style: CustomModalStyles,
    shouldCloseOnEsc: true
  }, /*#__PURE__*/React.createElement(ModalTitle, null, t(props.i18nKeyDeleteModalTitle)), t(props.i18nKeyDeleteModalMessage, {
    name: props.itemName
  }), /*#__PURE__*/React.createElement(ModalDeleteCloseButtonBar, {
    confirm: confirm,
    closeModal: closeModal
  }))));
});